import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=0083d6b2&scoped=true&"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=0083d6b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083d6b2",
  null
  
)

export default component.exports